import { getBuildingAmount } from "../../buildings/Buildings";
import lumberYard from "../../buildings/campus/LumberYard";
import {
  registerTransformation,
  TransformationType,
} from "../../calculation/Calculation";
import { TransformationTags } from "../../calculation/TransformationTags";
import {
  hasFlag,
  hasGlobalFlag,
  hasGlobalFlagIncludingNextRun,
  setFlag,
  setGlobalFlagForNextRun,
} from "../../Flags";
import { addContextListener } from "../../PlayerContextListeners";
import { Resource } from "../../Resources";
import { Storyline, Storylines } from "../../storylines/Storylines";
import { buildEvent } from "../EventMessageBuilder";
import { triggerEvent } from "../Events";
import { EventTag } from "../GameEvent";

const lumberingExpertiseEventBuilder = buildEvent(
  "lumbering_expertise",
  "(Storyline) Lumbering Expertise",
  [EventTag.STORYLINE],
);
lumberingExpertiseEventBuilder
  .setOnTrigger(setFlag("lumbering_expertise_triggered"))
  .createMessage()
  .setSimpleDescription(
    `As you observe your collection of Lumber Yards produce quite a lot of wood, you start thinking about their inner workings. Should you place a blade here, or perhaps enchant this other thing?
    
You lose yourself in thought, but then you happen to see the very first one you built, and... you have a realization. You have a great idea on how to build them so that they work much better! But it's too late... they are already built. It would be pretty much impossible to apply the improvements now.

You decide to search for your researcher...`,
  )
  .addOption(
    "Continue",
    { transform: setGlobalFlagForNextRun("lumbering_expertise_completed") },
    lumberingExpertiseEventBuilder.createMessage()
      .setSimpleDescription(`When you find her and tell her about your thoughts, she is visibly excited and urges you to write down your thoughts. "It might be too late now, but it will not be too late for others who come after us!", she exclaims.

You take her up on her offer, and put some effort into documenting your thoughts. Will someone really benefit from this...? Your researcher seems to be sure that someone will, even if you'll never end up seeing it...

**You have completed the "Lumbering Expertise" Storyline! In future runs, Lumber Yards will be three times as effective!**`),
  );

const lumberingExpertiseEvent = lumberingExpertiseEventBuilder.build();

addContextListener("LumberingExpertise", (newState) => {
  if (
    !hasGlobalFlagIncludingNextRun(newState, "lumbering_expertise_completed") &&
    !hasFlag(newState, "lumbering_expertise_triggered") &&
    getBuildingAmount(newState, lumberYard) >= 20
  ) {
    return triggerEvent(lumberingExpertiseEvent);
  }
});

registerTransformation(
  [[Resource.Wood, lumberYard.getName(), TransformationTags.Production]],
  "LumberingExpertise",
  TransformationType.Multiplier,
  (state) =>
    hasGlobalFlag(state, "lumbering_expertise_completed") ? 3.0 : 1.0,
);

Storylines.register(
  new Storyline(
    "Lumbering Expertise",
    2050,
    (state) =>
      hasGlobalFlagIncludingNextRun(state, "lumbering_expertise_completed"),
    (state) => hasGlobalFlag(state, "lumbering_expertise_completed"),
    "Build at least 20 Lumber Yards",
    "3x:wood: production from Lumber Yards",
    (state) => true,
  ),
);

export default lumberingExpertiseEvent;
